import { startOfWeek } from './calendarWeek';
import { localStamp } from './greeting';

/**
 * The staff week grid (SessionCalendar) places a chip by wall-clock strings in
 * the browser's zone. The members' API speaks in UTC instants, so each entry is
 * written out as wall clock where the viewer is before the grid sees it
 * (XN-4558). The viewer's zone is the browser's, so the grid reads it back
 * where it was written.
 */
export const toGridSession = (entry, timeZone) => ({
  ...entry,
  start_date: localStamp(new Date(entry.starts_at), timeZone),
  end_date: localStamp(new Date(entry.ends_at), timeZone),
  video_call_type: entry.kind,
});

/** Monday 00:00 to the next Monday 00:00 where the viewer is, as instants with an offset. */
export function memberWeekWindow(anchor) {
  const monday = startOfWeek(anchor);
  const next = new Date(monday);
  next.setDate(monday.getDate() + 7);

  return { from: monday.toISOString(), to: next.toISOString() };
}
